export default __webpack_public_path__ + "static/media/undraw_environment_iaus.0bac704c.svg";